"use strict";

// =====================================================
// REPORTES LIBRO
//
// Archivo:
// src/fronend/reportes/libro/libro.js
//
// =====================================================


// =====================================================
// VARIABLES
// =====================================================

let registrosreporteslibro = [];


// =====================================================
// ELEMENTOS DEL DOM
// =====================================================

const tbodyreporteslibro =
    document.getElementById("tbodyreporteslibro");

const buscarLibro =
    document.getElementById("buscarLibroSalarios");

const btnLimpiarBusquedaLibro =
    document.getElementById("btnLimpiarBusquedaLibro");

const totalEmpleadosLibro =
    document.getElementById("totalEmpleadosLibro");

const totalIngresosLibro =
    document.getElementById("totalIngresosLibro");

const totalEgresosLibro =
    document.getElementById("totalEgresosLibro");

const btnPDFLibroSalarios =
    document.getElementById("btnPDFLibroSalarios");


// =====================================================
// CARGAR REPORTE LIBRO
// =====================================================

const cargarReporteLibro = async () => {

    try {

        const respuesta =
            await fetch("/libro/listar");


        if (!respuesta.ok) {

            throw new Error(
                "No se pudo obtener el reporte de Libro de Salarios."
            );

        }


        registrosreporteslibro =
            await respuesta.json();


        console.log(
            "Reporte Libro:",
            registrosreporteslibro
        );


        mostrarReporteLibro(
            registrosreporteslibro
        );


        actualizarResumenLibro(
            registrosreporteslibro
        );


    } catch (error) {

        console.error(
            "Error al cargar el reporte de Libro:",
            error
        );


        if (tbodyreporteslibro) {

            tbodyreporteslibro.innerHTML = `

                <tr>

                    <td
                        colspan="8"
                        class="error-state">

                        <i class="bi bi-exclamation-triangle-fill"></i>

                        <div class="fw-bold mb-1">

                            Error al cargar el reporte

                        </div>

                        <div>

                            No se pudo obtener el
                            Libro de Salarios.

                        </div>

                    </td>

                </tr>

            `;

        }


        if (totalEmpleadosLibro) {

            totalEmpleadosLibro.textContent = "0";

        }


        if (totalIngresosLibro) {

            totalIngresosLibro.textContent =
                "Q 0.00";

        }


        if (totalEgresosLibro) {

            totalEgresosLibro.textContent =
                "Q 0.00";

        }

    }

};


// =====================================================
// MOSTRAR REPORTE LIBRO
// =====================================================

const mostrarReporteLibro = (registros) => {

    if (!tbodyreporteslibro) {

        return;

    }


    tbodyreporteslibro.innerHTML = "";


    // =================================================
    // SIN REGISTROS
    // =================================================

    if (
        !registros ||
        registros.length === 0
    ) {

        tbodyreporteslibro.innerHTML = `

            <tr>

                <td
                    colspan="8"
                    class="empty-state">

                    <i class="bi bi-journal-x"></i>

                    <div class="fw-bold mb-1">

                        No hay registros disponibles

                    </div>

                    <div>

                        No se encontraron datos
                        en el Libro de Salarios.

                    </div>

                </td>

            </tr>

        `;

        return;

    }


    // =================================================
    // RECORRER REGISTROS
    // =================================================

    registros.forEach(
        (registro, indice) => {

            const fila =
                document.createElement("tr");


            // =========================================
            // NOMBRE EMPLEADO
            // =========================================

            const nombreEmpleado =
                String(
                    registro.NOMBREEMPLEADO ?? ""
                ).trim();


            // =========================================
            // INICIAL
            // =========================================

            const inicial =
                nombreEmpleado
                    ? nombreEmpleado
                        .charAt(0)
                        .toUpperCase()
                    : "E";


            // =========================================
            // FILA
            // =========================================

            fila.innerHTML = `

                <td class="numero text-center">

                    ${indice + 1}

                </td>


                <td>

                    <div class="department">

                        <i class="bi bi-building"></i>

                        ${registro.NOMBRETECNOLOGICO ?? ""}

                    </div>

                </td>


                <td>

                    <div class="employee-cell">

                        <div class="employee-avatar">

                            ${inicial}

                        </div>


                        <span class="employee-name">

                            ${nombreEmpleado}

                        </span>

                    </div>

                </td>


                <td class="salary text-end">

                    Q ${formatearMoneda(
                        registro["SUELDO BASE"]
                    )}

                </td>


                <td class="days text-center">

                    <span class="days-badge">

                        ${registro["DIAS LABORALES"] ?? 0}

                    </span>

                </td>


                <td class="income text-end">

                    Q ${formatearMoneda(
                        registro["TOTAL DE INGRESOS"]
                    )}

                </td>


                <td class="expense text-end">

                    Q ${formatearMoneda(
                        registro["TOTAL DE EGRESOS"]
                    )}

                </td>


                <td class="salary text-end fw-bold">

                    Q ${formatearMoneda(
                        registro["SUELDO NUEVO"]
                    )}

                </td>

            `;


            tbodyreporteslibro.appendChild(
                fila
            );

        }
    );

};


// =====================================================
// ACTUALIZAR RESUMEN
// =====================================================

const actualizarResumenLibro = (registros) => {

    if (!registros) {

        return;

    }


    // =================================================
    // TOTAL EMPLEADOS
    // =================================================

    if (totalEmpleadosLibro) {

        totalEmpleadosLibro.textContent =
            registros.length;

    }


    // =================================================
    // TOTAL INGRESOS
    // =================================================

    let totalIngresos = 0;


    registros.forEach(
        (registro) => {

            totalIngresos +=
                Number(
                    registro["TOTAL DE INGRESOS"]
                ) || 0;

        }
    );


    // =================================================
    // TOTAL EGRESOS
    // =================================================

    let totalEgresos = 0;


    registros.forEach(
        (registro) => {

            totalEgresos +=
                Number(
                    registro["TOTAL DE EGRESOS"]
                ) || 0;

        }
    );


    // =================================================
    // MOSTRAR INGRESOS
    // =================================================

    if (totalIngresosLibro) {

        totalIngresosLibro.textContent =
            `Q ${formatearMoneda(totalIngresos)}`;

    }


    // =================================================
    // MOSTRAR EGRESOS
    // =================================================

    if (totalEgresosLibro) {

        totalEgresosLibro.textContent =
            `Q ${formatearMoneda(totalEgresos)}`;

    }

};


// =====================================================
// FORMATEAR MONEDA
// =====================================================

const formatearMoneda = (valor) => {

    const numero =
        Number(valor) || 0;


    return numero.toLocaleString(
        "es-GT",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );

};


// =====================================================
// BUSCAR EN EL REPORTE
// =====================================================

const filtrarReporteLibro = () => {

    const texto =
        buscarLibro
            ? buscarLibro.value
                .trim()
                .toLowerCase()
            : "";


    // =================================================
    // SIN TEXTO
    // =================================================

    if (!texto) {

        mostrarReporteLibro(
            registrosreporteslibro
        );


        actualizarResumenLibro(
            registrosreporteslibro
        );

        return;

    }


    // =================================================
    // FILTRAR
    // =================================================

    const registrosFiltrados =
        registrosreporteslibro.filter(
            (registro) => {

                const departamento =
                    String(
                        registro.NOMBRETECNOLOGICO ?? ""
                    ).toLowerCase();


                const empleado =
                    String(
                        registro.NOMBREEMPLEADO ?? ""
                    ).toLowerCase();


                return (

                    departamento.includes(texto) ||

                    empleado.includes(texto)

                );

            }
        );


    // =================================================
    // MOSTRAR FILTRADOS
    // =================================================

    mostrarReporteLibro(
        registrosFiltrados
    );


    // =================================================
    // ACTUALIZAR RESUMEN
    // =================================================

    actualizarResumenLibro(
        registrosFiltrados
    );

};


// =====================================================
// EVENTO BUSCAR
// =====================================================

if (buscarLibro) {

    buscarLibro.addEventListener(
        "input",
        filtrarReporteLibro
    );

}


// =====================================================
// LIMPIAR B�SQUEDA
// =====================================================

if (btnLimpiarBusquedaLibro) {

    btnLimpiarBusquedaLibro.addEventListener(
        "click",
        () => {

            if (buscarLibro) {

                buscarLibro.value = "";

            }


            mostrarReporteLibro(
                registrosreporteslibro
            );


            actualizarResumenLibro(
                registrosreporteslibro
            );

        }
    );

}


// =====================================================
// CARGAR LIBRER�A jsPDF
// =====================================================

const cargarJsPDF = () => {

    return new Promise(
        (resolve, reject) => {

            if (
                window.jspdf &&
                window.jspdf.jsPDF
            ) {

                resolve();

                return;

            }


            const script =
                document.createElement("script");


            script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";


            script.onload = () => {

                resolve();

            };


            script.onerror = () => {

                reject(
                    new Error(
                        "No se pudo cargar jsPDF."
                    )
                );

            };


            document.head.appendChild(
                script
            );

        }
    );

};


// =====================================================
// CARGAR jsPDF-AUTO-TABLE
// =====================================================

const cargarAutoTable = () => {

    return new Promise(
        (resolve, reject) => {

            if (
                window.jspdf &&
                window.jspdf.jsPDF &&
                window.jspdf.jsPDF.API &&
                window.jspdf.jsPDF.API.autoTable
            ) {

                resolve();

                return;

            }


            const script =
                document.createElement("script");


            script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js";


            script.onload = () => {

                resolve();

            };


            script.onerror = () => {

                reject(
                    new Error(
                        "No se pudo cargar jsPDF-AutoTable."
                    )
                );

            };


            document.head.appendChild(
                script
            );

        }
    );

};


// =====================================================
// GENERAR PDF
// =====================================================

const generarPDFLibro = async () => {

    try {

        // =============================================
        // VALIDAR REGISTROS
        // =============================================

        if (
            !registrosreporteslibro ||
            registrosreporteslibro.length === 0
        ) {

            alert(
                "No hay datos para generar el PDF."
            );

            return;

        }


        // =============================================
        // CAMBIAR ESTADO DEL BOT�N
        // =============================================

        const textoOriginal =
            btnPDFLibroSalarios
                ? btnPDFLibroSalarios.innerHTML
                : "";


        if (btnPDFLibroSalarios) {

            btnPDFLibroSalarios.disabled = true;

            btnPDFLibroSalarios.innerHTML = `

                <span
                    class="spinner-border spinner-border-sm me-2">
                </span>

                Generando PDF...

            `;

        }


        // =============================================
        // CARGAR LIBRER�AS
        // =============================================

        await cargarJsPDF();

        await cargarAutoTable();


        // =============================================
        // CREAR DOCUMENTO
        // =============================================

        const {
            jsPDF
        } = window.jspdf;


        const doc =
            new jsPDF({
                orientation: "landscape",
                unit: "mm",
                format: "letter"
            });


        // =============================================
        // DATOS FILTRADOS ACTUALES
        // =============================================

        const textoBusqueda =
            buscarLibro
                ? buscarLibro.value
                    .trim()
                    .toLowerCase()
                : "";


        let registrosPDF =
            registrosreporteslibro;


        if (textoBusqueda) {

            registrosPDF =
                registrosreporteslibro.filter(
                    (registro) => {

                        const departamento =
                            String(
                                registro.NOMBRETECNOLOGICO ?? ""
                            ).toLowerCase();


                        const empleado =
                            String(
                                registro.NOMBREEMPLEADO ?? ""
                            ).toLowerCase();


                        return (

                            departamento.includes(
                                textoBusqueda
                            ) ||

                            empleado.includes(
                                textoBusqueda
                            )

                        );

                    }
                );

        }


        // =============================================
        // ENCABEZADO
        // =============================================

        doc.setFont(
            "helvetica",
            "bold"
        );


        doc.setFontSize(18);


        doc.text(
            "CONSULTING S.A.",
            14,
            15
        );


        doc.setFontSize(14);


        doc.text(
            "LIBRO DE SALARIOS",
            14,
            23
        );


        doc.setFont(
            "helvetica",
            "normal"
        );


        doc.setFontSize(9);


        doc.text(
            "Control y detalle de salarios de empleados",
            14,
            30
        );


        // =============================================
        // FECHA
        // =============================================

        const fecha =
            new Date().toLocaleDateString(
                "es-GT"
            );


        doc.text(
            `Fecha de Registro: ${fecha}`,
            14,
            36
        );


        // =============================================
        // RESUMEN
        // =============================================

        let totalIngresosPDF = 0;

        let totalEgresosPDF = 0;

        let totalSueldoNuevoPDF = 0;


        registrosPDF.forEach(
            (registro) => {

                totalIngresosPDF +=
                    Number(
                        registro["TOTAL DE INGRESOS"]
                    ) || 0;


                totalEgresosPDF +=
                    Number(
                        registro["TOTAL DE EGRESOS"]
                    ) || 0;


                totalSueldoNuevoPDF +=
                    Number(
                        registro["SUELDO NUEVO"]
                    ) || 0;

            }
        );


        doc.setFont(
            "helvetica",
            "bold"
        );


        doc.text(
            `Empleados: ${registrosPDF.length}`,
            180,
            15
        );


        doc.text(
            `Ingresos: Q ${formatearMoneda(totalIngresosPDF)}`,
            180,
            22
        );


        doc.text(
            `Egresos: Q ${formatearMoneda(totalEgresosPDF)}`,
            180,
            29
        );


        doc.text(
            `Sueldos Netos: Q ${formatearMoneda(totalSueldoNuevoPDF)}`,
            180,
            36
        );


        // =============================================
        // DATOS DE LA TABLA
        // =============================================

        const datosTabla =
            registrosPDF.map(
                (registro, indice) => {

                    return [

                        indice + 1,

                        registro.NOMBRETECNOLOGICO ?? "",

                        registro.NOMBREEMPLEADO ?? "",

                        `Q ${formatearMoneda(
                            registro["SUELDO BASE"]
                        )}`,

                        registro["DIAS LABORALES"] ?? 0,

                        `Q ${formatearMoneda(
                            registro["TOTAL DE INGRESOS"]
                        )}`,

                        `Q ${formatearMoneda(
                            registro["TOTAL DE EGRESOS"]
                        )}`,

                        `Q ${formatearMoneda(
                            registro["SUELDO NUEVO"]
                        )}`

                    ];

                }
            );


        // =============================================
        // CREAR TABLA PDF
        // =============================================

        doc.autoTable({

            startY: 42,

            head: [[

                "#",

                "Departamento",

                "Empleado",

                "Sueldo Base",

                "Dias Laborales",

                "Total de Ingresos",

                "Total de Egresos",

                "Sueldo Nuevo"

            ]],


            body: datosTabla,


            theme: "grid",


            styles: {

                font: "helvetica",

                fontSize: 7.5,

                cellPadding: 2.5,

                valign: "middle"

            },


            headStyles: {

                fontStyle: "bold",

                halign: "center"

            },


            columnStyles: {

                0: {

                    halign: "center",

                    cellWidth: 9

                },

                1: {

                    cellWidth: 42

                },

                2: {

                    cellWidth: 52

                },

                3: {

                    halign: "right",

                    cellWidth: 30

                },

                4: {

                    halign: "center",

                    cellWidth: 20

                },

                5: {

                    halign: "right",

                    cellWidth: 30

                },

                6: {

                    halign: "right",

                    cellWidth: 30

                },

                7: {

                    halign: "right",

                    cellWidth: 30

                }

            },


            margin: {

                left: 14,

                right: 14

            },


            didDrawPage: function () {

                // =================================
                // PIE DE P�GINA
                // =================================

                const numeroPagina =
                    doc.internal.getNumberOfPages();


                doc.setFontSize(8);

                doc.setFont(
                    "helvetica",
                    "normal"
                );


                doc.text(
                    `P�gina ${numeroPagina}`,
                    14,
                    doc.internal.pageSize.height - 8
                );


                doc.text(
                    "Consulting S.A. - Libro de Salarios",
                    doc.internal.pageSize.width - 75,
                    doc.internal.pageSize.height - 8
                );

            }

        });


        // =============================================
        // NOMBRE DEL ARCHIVO
        // =============================================

        const fechaArchivo =
            new Date()
                .toISOString()
                .split("T")[0];


        const nombreArchivo =
            `Libro_de_Salarios_${fechaArchivo}.pdf`;


        // =============================================
        // DESCARGAR PDF
        // =============================================

        doc.save(
            nombreArchivo
        );


        // =============================================
        // RESTAURAR BOT�N
        // =============================================

        if (btnPDFLibroSalarios) {

            btnPDFLibroSalarios.disabled =
                false;

            btnPDFLibroSalarios.innerHTML =
                textoOriginal;

        }


    } catch (error) {

        console.error(
            "Error al generar PDF:",
            error
        );


        alert(
            "No se pudo generar el PDF del Libro de Salarios."
        );


        if (btnPDFLibroSalarios) {

            btnPDFLibroSalarios.disabled =
                false;

            btnPDFLibroSalarios.innerHTML = `

                <i
                    class="bi bi-file-earmark-pdf-fill me-2">
                </i>

                Generar PDF

            `;

        }

    }

};


// =====================================================
// EVENTO BOTON PDF
// =====================================================

if (btnPDFLibroSalarios) {

    btnPDFLibroSalarios.addEventListener(
        "click",
        generarPDFLibro
    );

}


// =====================================================
// INICIAR
// =====================================================

document.addEventListener(
    "DOMContentLoaded",
    () => {

        cargarReporteLibro();

    }
);
